module.exports = __webpack_public_path__ + "media/testimonials-video.cfc50bf6.mp4";